import { ApiService } from "./ApiService/ApiService";
import { urlConfig } from "../config/urlConfig";

export const submitContactFormApi = (data) => {
  return ApiService.post(urlConfig?.contact?.submit, data);
};
